// 环境变量
export const host = {
  local: "local", // 本地
  development: "development", // dev
  stage: "stage", // stage
  test: "test", // test
  test2: "test2", // test2
  production: "production", // prod
};

// 环境判断
export const hostEnv = {
  isLocal: process.env.ENV_NAME === host.local,
  isDev: process.env.ENV_NAME === host.development,
  isTest: process.env.ENV_NAME === host.test,
  isTest2: process.env.ENV_NAME === host.test2,
  isProd: process.env.ENV_NAME === host.production,
  isStage: process.env.ENV_NAME === host.stage,
};

// 是否是开发测试环境
export const isDevTest = hostEnv.isDev || hostEnv.isTest || hostEnv.isTest2;
// 埋点环境判断
export const sensorsEnv = hostEnv.isProd || hostEnv.isTest || hostEnv.isTest2 || hostEnv.isLocal;
// 友盟监控环境
export const umengEnv = hostEnv.isTest || hostEnv.isProd;
